import { render, staticRenderFns } from "./Covid19.vue?vue&type=template&id=2c094b7e&scoped=true&"
import script from "./Covid19.vue?vue&type=script&lang=js&"
export * from "./Covid19.vue?vue&type=script&lang=js&"
import style0 from "./Covid19.vue?vue&type=style&index=0&id=2c094b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c094b7e",
  null
  
)

export default component.exports